import { take, call, fork, put } from "redux-saga/effects";
import { callServer, padRootUrl } from "~/api/call-server";
import { handleErrorSaga } from "./error-handling-saga";
import { BookOfTheMonthActionTypes } from "../reducers/book-of-the-month/book-of-the-month-types";
import { ISkipBookOfTheMonthRequest } from "../reducers/book-of-the-month/book-of-the-month-actions";
import { ISkipBookOfTheMonthResponse } from "~/api/response-types/skip-book-of-the-month-response";

function* skipBookOfTheMonthApiCall({ skipBookOfTheMonthWebApiUrl, productId }: ISkipBookOfTheMonthRequest) {
    try {
        const response: ISkipBookOfTheMonthResponse = yield call(
            callServer,
            padRootUrl(skipBookOfTheMonthWebApiUrl),
            "post",
            {
                skipBookOfTheMonthWebApiUrl,
                productId
            }
        );
        yield put({
            type: BookOfTheMonthActionTypes.SKIP_BOTM_SUCCESS,
            payload: response.payload
        });
    } catch (error) {
        yield put({ type: BookOfTheMonthActionTypes.SKIP_BOTM_ERROR, payload: error });
    }
}

function* skipBookOfTheMonthWorkerSaga(payload: ISkipBookOfTheMonthRequest) {
    yield fork(skipBookOfTheMonthApiCall, payload);

    const result = yield take([
        BookOfTheMonthActionTypes.SKIP_BOTM_SUCCESS,
        BookOfTheMonthActionTypes.SKIP_BOTM_ERROR
    ]);

    if (result.type === BookOfTheMonthActionTypes.SKIP_BOTM_ERROR) {
        const { error } = result.payload;

        yield call(handleErrorSaga, { ...error, showErrorInModal: true });
    }
}

export default function* bookOfTheMonthSaga() {
    while (true) {
        const action = yield take([BookOfTheMonthActionTypes.SKIP_BOTM_REQUEST]);

        if (action.type === BookOfTheMonthActionTypes.SKIP_BOTM_REQUEST) {
            yield fork(skipBookOfTheMonthWorkerSaga, action.payload);
        }
    }
}
